(function ($) {
  $.fn.wsHeader = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.showC2a();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }
  }

  let showC2a = this.showC2a = function () {
    let header = $('.elementor-widget-ws-header');
    let c2a = header.find('a');
    if ($(window).width() <= 1024) {
      c2a.appendTo($('.blob-content'));
      c2a.css('font-size', '1.5rem');
    } else {
      c2a.appendTo($('.wolkyheader-text'));
    }
  }

  showC2a();

  $(window).resize(function () {
    showC2a();
  });
})(jQuery);
